import React, { useState } from 'react';
import { bulkCancelShipmentService } from '../../store/actions/batch.action';
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';

/*istanbul ignore next */
const SubmitRequest = () => {
    const [query, setQuery] = useState('');
    const [refundReason, setRefundReason] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const dispatch = useDispatch();

    const handleSubmitRequest = async (e) => {
        e.preventDefault();
        let data = {
            trackingNumbers: query,
            refundReason: refundReason,
        };
        setShowLoader(true);
        let bulkRes = await Promise.resolve(dispatch(bulkCancelShipmentService(data)));
        if (bulkRes?.data?.Status === 200) {
            setShowLoader(false);
            toast.success('Refund request raised successfully');
            setRefundReason('');
            setQuery('');
        } else {
            setShowLoader(false);
            toast.error(bulkRes.data.Message.AppStatusDescription);
        }
    };

    return (
        <div className='queryBox'>
            <h2 className='mb-4'>Generate refundable transactions</h2>
            <p className='mb-1'>Please enter tracking numbers, separated by commas</p>
            <textarea placeholder='Tracking Number 1, Tracking Number 2...' value={query} type='text' className='form-control requestArea' rows={5} onChange={(e) => setQuery(e.target.value)} />

            <p className='mt-3 mb-1'>Cancellation Reason</p>
            <textarea placeholder='Enter reason' value={refundReason} type='text' className='form-control requestArea' rows={2} onChange={(e) => setRefundReason(e.target.value)} />
            <div className='actions mt-3 alignRight p-0'>
                <button
                    disabled={!query || showLoader}
                    className="btn cus-seconday-bg-btn"
                    onClick={handleSubmitRequest}
                >Submit Reuest</button>
            </div>
        </div>
    );
}

export default SubmitRequest;